<template lang="pug">
  footer(class="footer border-top text-dark py-4 px-3")
    div(class="container")
      div(class="row align-items-end")
        div(class="col-12 d-flex justify-content-center py-3")
          div(class="logo")
            img(src="https://api.tocin.com.tw/storage/system_images/V5NaTDZC3KvuiJczkWRTWUZoGh8sL3IS6nnWVi8H.svg" width="67" height="98")
        div(class="col-xl-4 d-flex justify-content-center")
          div()
            div(class="d-flex justify-content-center mb-3")
              a(class="btn btn-icon text-secondary transition-ease" href="https://www.facebook.com/tocin1993/")
                Icon(class="mx-2" pattern="FacebookNative" size="24")
              a(class="btn btn-icon text-secondary transition-ease" href="https://lin.ee/TTFWqKr")
                Icon(class="mx-2" pattern="LineNative" size="24")
              a(class="btn btn-icon text-secondary transition-ease" href="https://www.youtube.com/channel/UCOat5l-OeZMLWN6fUtGSIeg")
                Icon(class="mx-2" pattern="YoutubeNative" size="24")
        div(class="col-xl-8 text-center pt-xl-0")
          div(class="transition-ease")
            span 地址：台中市西屯區市政路402號26樓之2
          div(class="d-flex flex-column justify-content-center")
            span(class="d-block py-1 transition-ease")
              span 電話：04-22581569
            div(class="vertical-line bg-light mx-2 transition-ease")
            span(class="d-block py-1 transition-ease")
              span 傳真：04-22581529
          div(class="fs-12 pt-4 transition-ease") 東震股份有限公司版權所有 2021 Q TOCIN CORP. All Rights Reserved.
</template>
<script>
import getNodeTree from '../node-tree'
import { mapState } from 'vuex'
import { getBrowseCount } from '@/api'

export default {
  name: 'Footer',
  data () {
    return {
      browseData: 0
    }
  },
  computed: {
    getNodeTree () {
      const nodeTree = getNodeTree.call(this, this.global.router)
      this.Categories.data.forEach(item => {
        const route = {
          name: `ProducteList-${item.id}`,
          path: item.id <= 0 ? '/product/list' : `/product/list?category_id=${item.id}`,
          meta: {
            title: item.name
          }
        }
        const nodeTree = this.$router.options.routes.find(r => r.name === 'Product').children
        const cacheRoute = nodeTree.find(r => r.name === route.name)
        if (cacheRoute) {
          Object.keys(cacheRoute).forEach(key => {
            cacheRoute[key] = route[key]
          })
        } else {
          nodeTree.push(route)
        }
      })
      return nodeTree
    },
    browseCount () {
      const arr = new Array(9).fill('0')
      const str = String(this.browseData)
      str.split('').reverse().forEach((s, i) => {
        arr[i] = s
      })
      const count = arr.reverse()
      // console.log('this.browseData,', this.browseData)
      return count
    },
    ...mapState({
      global: state => state.global,
      Seometas: state => state.model.Seometas,
      Categories: state => state.model.Categories,
      SystemImages: state => state.model.SystemImages,
      SystemRights: state => state.model.SystemRights
    })
  },
  methods: {
    isRouteRender (route) {
      // console.log(route.children)
      return route.children && route.children.filter(p => !p.meta.hidden).length > 1
    },
    isNextPath (route) {
      return route.children && route.children.length >= 1 && !/^:/.test(route.children[0].path)
    },
    routeRender (routes) {
      // console.log('UserData,', this.UserData.id)
      return routes.filter(p => {
        if (!p.meta) {
          return true
        }
        return !p.meta.hidden
      }).map(route => {
        return {
          ...route,
          isRender: this.isRouteRender(route),
          path: this.isNextPath(route) ? route.children[0].path : route.path
        }
      })
    }
  },
  updated () {
    getBrowseCount().then(res => {
      this.browseData = res.data
    })
  },
  mounted () {
    getBrowseCount().then(res => {
      this.browseData = res.data
    })
  }
}
</script>
<style lang="scss" scoped>
  .navbar{
    > ul{
      list-style:  none;
      > li{
        > a{
          color: #979797;
          padding: 0.5rem 0;
          display: block;
        }
        > ul{
          padding: 0;
          list-style:  none;
          > li{
            > a{
                color: #979797;
                padding: 0.5rem 0;
                display: block;
            }
          }
        }
      }
    }
  }
  .browse-number{
    background-color: #979797;
    width: 20px;
    font-size: 16px;
  }
  .hover-opacity{
    &:hover {
      font-weight: bold;
      color: #424242;
    }
  }
  .col-xl-8 {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    flex: 1;
    max-width: 100%;
  }
  .col-xl-4 {
    flex: auto;
    max-width: 100%;
  }
</style>
